// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"FixcenterNavigation_breadcrumbs__KqVHb","breadcrumbs__item":"FixcenterNavigation_breadcrumbs__item__OCRgn","active":"FixcenterNavigation_active__K8p+t"};